import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MarketsDropdown.css';

const MarketsDropdown = ({  onClose, dropdownRef  }) => {
  const [marketData, ] = useState({
    topSecurities: [
      { name: 'S&P 500', value: '6,921.46', change: '0.01%', isPositive: true },
      { name: 'Nasdaq', value: '23,480.02', change: '0.44%', isNegative: true },
      { name: 'FTSE 100', value: '10,060.45', change: '0.16%', isPositive: true },
      { name: 'Dow Jones', value: '43,266.11', change: '0.55%', isPositive: true },
      { name: 'Russell 2000', value: '2,603.91', change: '1.11%', isPositive: true },
      { name: 'Nikkei 225', value: '51,939.89', change: '1.61%', isPositive: true },
      { name: 'Hang Seng', value: '26,199.90', change: '0.19%', isNegative: true },
      { name: 'DAX', value: '25,127.46', change: '0.02%', isPositive: true },
      { name: 'Crude Oil', value: '58.24', change: '0.83%', isPositive: true },
       { name: 'Gold', value: '4,484.00', change: '0.52%', isPositive: true },
       { name: 'EUR/USD', value: '1.16', change: '0.14%', isNegative: true },
       { name: 'GBP/USD', value: '1.34', change: '0.10%', isNegative: true }
    ]
  });

  

  

  return (
    <>
     {/* <div className="markets-dropdown-overlay" 
    //  onClick={onClose} 
     aria-hidden="true">

     </div> */}

     {/* <div ref={dropdownRef} 
     className="markets-dropdown" 
     role="dialog"
      aria-label="Markets Menu"  
       onClick={onClose} > */}
       
            <div
           ref={dropdownRef}
          className="markets-dropdown"
          role="dialog"
          aria-label="Markets Menu"
           onMouseEnter={() => clearTimeout(window.marketsTimeout)}
          onMouseLeave={() => {
          window.marketsTimeout = setTimeout(() => {
             onClose();
             }, 300);
          }} 
   > 
      
  
   


          

        <div className="markets-dropdown-container">
          {/* Left Column - News Menu */}
          <div className="markets-column markets-menu-column">
            <h3 className="markets-column-title">News</h3>
            <nav aria-label="Markets Navigation">
              <ul className="markets-menu-list">
                <li>
                  <Link to="/markets/deals" className="markets-menu-item" onClick={onClose} >
                    <span className="markets-menu-label">Deals</span>
                  </Link>
                </li>
                <li>
                  <Link to="/markets/fixed-income" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Fixed Income</span>
                  </Link>
                </li>
                <li>
                  <Link to="/markets/etfs" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">ETFs</span>
                  </Link>
                </li>
                <li>
                  <Link to="/markets/fx" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">FX</span>
                  </Link>
                </li>
                <li>
                  <Link to="/markets/alternative-investing" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Alt. Investing</span>
                  </Link>
                </li>
                <li>
                  <Link to="/markets/economic-calendar" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Economic Calendar</span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Middle Column - Data Menu */}
          <div className="markets-column markets-data-column">
            <h3 className="markets-column-title">Data</h3>
            <nav aria-label="Market Data">
              <ul className="markets-menu-list">
                <li>
                  <Link to="/article/tech-stocks-lead-market-gains" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Stocks</span>
                  </Link>
                </li>
                <li>
                  <Link to="/article/inflation-trends-moderation" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Futures</span>
                  </Link>
                </li>
                <li>
                  <Link to="/article/treasury-yields-higher" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Rates & Bonds</span>
                  </Link>
                </li>
                <li>
                  <Link to="/article/dollar-strengthens" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Currencies</span>
                  </Link>
                </li>
                <li>
                  <Link to="/article/oil-prices-fluctuate" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Commodities</span>
                  </Link>
                </li>
                <li>
                  <Link to="/article/electric-vehicle-sales-surge" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Sectors</span>
                  </Link>
                </li>
                <li>
                  <Link to="/article/renewable-energy-investment-high" className="markets-menu-item" onClick={onClose}>
                    <span className="markets-menu-label">Energy</span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Right Column - Top Securities */}
          <div className="markets-column markets-securities-column">
            <h3 className="markets-column-title">Top Securities</h3>
            <div className="markets-securities-grid">
              {marketData.topSecurities.map((security, index) => (
                <Link 
                  to={`/markets/quote/${security.name.toLowerCase().replace(/\s+/g, '-')}`}
                  key={index} 
                  className="security-item"
                  aria-label={`${security.name} at ${security.value}, ${security.change}`}
                  onClick={onClose}
                >
                  <div className="security-name">{security.name}</div>
                  <div className="security-value">{security.value}</div>
                  <div className={`security-change ${security.isPositive ? 'positive' : security.isNegative ? 'negative' : ''}`}>
                    <span className="change-icon">{security.isPositive ? '▲' : security.isNegative ? '▼' : ''}</span>
                    {security.change}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketsDropdown;














